import React from 'react';
import Box from '@mui/material/Box';
import Button from './Button';
import { useTranslation } from 'react-i18next';

interface ModalFooterProps {
  onCancel: () => void;
  onSubmit: () => void;
  cancelText?: string;
  submitText?: string;
  isLoading?: boolean;
  cancelVariant?: 'blue' | 'outlinedBlue' | 'red' | 'gray' | 'text' | 'blueFont' | 'outlinedRed';
  submitVariant?: 'blue' | 'outlinedBlue' | 'red' | 'gray' | 'text' | 'blueFont' | 'outlinedRed';
  disabled?: boolean;
}

const ModalFooter: React.FC<ModalFooterProps> = ({
  onCancel,
  onSubmit,
  cancelText,
  submitText,
  isLoading = false,
  cancelVariant = 'red',
  submitVariant = 'outlinedBlue',
  disabled = false,
}) => {
  const { t } = useTranslation();
  const finalCancelText = cancelText || t('buttons.cancel');
  const finalSubmitText = submitText || t('buttons.submit');
  return (
    <Box display="flex" gap={2} justifyContent="flex-end">
      <Button variant={cancelVariant} onClick={onCancel} disabled={isLoading || disabled}>
        {finalCancelText}
      </Button>
      <Button
        variant={submitVariant}
        onClick={onSubmit}
        isLoading={isLoading}
        disabled={isLoading || disabled}
      >
        {finalSubmitText}
      </Button>
    </Box>
  );
};

export default ModalFooter;
